import { createSvgComponent } from "../../icon/createSvgComponent";
import SnackbarCheck from "@core/__generated__/icon/figma/Snackbar/check.svg";
export default createSvgComponent(SnackbarCheck);